// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"908761aa","41":"51199a83","89":"25857719","253":"0d7dcf75","433":"df825010","453":"010710b9","590":"66d6c7a5","693":"5db76260"}[chunkId] + ".chunk.js";
};